import React from 'react';
import styled from 'astroturf/react';

import { resolveNavImpactStats } from '../autotest/AutotestNavImpactStats';
import type { ImpactStats } from '../types';

export const NAV_IMPACT_STRIP_MIN_WIDTH = 140;

type NavImpactStatsProps = {
  arm: string | null | undefined;
  impactStats?: ImpactStats | null;
  isMobileNav?: boolean;
};

const StripContainer = styled.div<{ isMobileNav?: boolean }>`
  flex: 0 0 auto;
  width: ${NAV_IMPACT_STRIP_MIN_WIDTH}px;
  min-width: ${NAV_IMPACT_STRIP_MIN_WIDTH}px;
  height: 48px;

  &.isMobileNav {
    height: 40px;
  }
`;

const NavImpactStats = ({ arm, isMobileNav = false }: NavImpactStatsProps) => {
  const surfaces = resolveNavImpactStats(arm);
  if (surfaces.statStyle === 'none') {
    return null;
  }

  return (
    <StripContainer data-testid="nav-impact-stats" isMobileNav={isMobileNav} />
  );
};

export default NavImpactStats;
